import { useEffect, useState, useRef, useMemo } from "react";
import { toast } from "react-toastify";
import { http } from "../auth";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { FaCopy } from "react-icons/fa";
import { useForm, Controller } from "react-hook-form";
import CurrencyField from "../utils/currencyField";
import { today } from "../utils/dateUtils";
import { bancos, telefonos, documento } from "../utils/bancos";
import { FiCalendar, FiCheck } from "react-icons/fi";
import { RxCross1, RxCross2 } from "react-icons/rx";
import { useThemeManager } from "../Hooks/ThemeManager";

const PagoP2P = ({ id_doc, id_servicio, factura, onBankChange, totalAPagar, totalAPagarLoading }) => {
  const token = localStorage.getItem("token");
  const { themeColors } = useThemeManager();
  const [selectedBankName, setSelectedBankName] = useState(null);
  const [copiedField, setCopiedField] = useState(null);

  const [iconMessage, setIconMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [nacionalidad, setNacionalidad] = useState("V");
  const [ci, setCi] = useState("");
  const [telefono, setTelefono] = useState([]);
  const [activate, setActivate] = useState([]);
  const [url, setUrl] = useState("");
  const [notification, setNotification] = useState(false);
  const [notification2, setNotification2] = useState(false);
  const [referencia, setReferencia] = useState("");
  const [msg, setMsg] = useState("");
  const [step, setStep] = useState(false);
  const [ref, setRef] = useState("");
  const [initialLoading, setInitialLoading] = useState(true);
  const customId = "custom-id-yes";
  
  // Ref para controlar el primer renderizado
  const isFirstRender = useRef(true);

  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const fechaRef = useRef(null);
  const hiddenDateRef = useRef(null);

  const [displayDate, setDisplayDate] = useState(() => {
    const [y, m, d] = today.split('-');
    return `${d}/${m}/${y}`;
  });

  const handleDateChange = (e) => {
    let val = e.target.value.replace(/[^0-9/]/g, '');

    if (val.length === 2 && !val.includes('/')) val += '/';
    if (val.length === 5 && val[2] === '/' && !val.includes('/', 3)) val += '/';

    if (val.length > 10) return;
    setDisplayDate(val);

    const parts = val.split('/');
    if (parts.length === 3) {
      const [d, m, y] = parts;
      if (d.length === 2 && m.length === 2 && y.length === 4) {
        setValue("date", `${y}-${m}-${d}`);
      }
    }
  };

  const handleIconClick = () => {
    if (hiddenDateRef.current) {
      hiddenDateRef.current.showPicker?.();
      hiddenDateRef.current.focus();
      hiddenDateRef.current.click();
    }
  };

  const handleHiddenDateChange = (e) => {
    const val = e.target.value;
    if (!val) return;
    const [y, m, d] = val.split('-');
    const formatted = `${d}/${m}/${y}`;
    setDisplayDate(formatted);
    setValue("date", val);
  };

  useEffect(() => {
    setValue("date", today);
  }, [setValue]);

  // Efecto para actualizar el monto SOLO cuando totalAPagar cambie y el banco sea Venezuela
  useEffect(() => {
    // Solo actualizar si es Banco de Venezuela y hay un monto válido
    if (selectedBankName === "Banco de Venezuela" && totalAPagar && parseFloat(totalAPagar) > 0) {
      const monto = parseFloat(totalAPagar);
      setValue("amount", monto);

    }
  }, [totalAPagar, selectedBankName, setValue]);

  // Efecto para actualizar URL según el banco seleccionado
  useEffect(() => {
    if (selectedBankName === "Banco de Venezuela") {
      setUrl("/bdv/p2p-j");
    } else if (selectedBankName === "Banco Plaza") {
      setUrl("/bp/p2p-j");
    }
      else if (selectedBankName === "Banco R4") {
      setUrl("/r4/p2p-j")
    }
      else if (selectedBankName === "Banco Mercantil") {
      setUrl("/bm/p2p-j")
    }
  }, [selectedBankName]);

  const copyToClipboard = (text, field) => {
    setCopiedField(field);
    setTimeout(() => setCopiedField(null), 600);
    navigator.clipboard
      .writeText(text)
      .catch((err) => console.error("Error al copiar el texto: ", err));
  };

  const mediosOnline = async () => {
    try {
      let response = await http.get(`/config/estado_medios_online`);
      setActivate(response.data);
    } catch (error) {
      if (![200, 401].includes(error?.response?.status)) {
        toast.error("Ocurrio un error al cargar los medios online");
      }
    } finally {
      setInitialLoading(false);
    }
  };

  useEffect(() => {
    mediosOnline();
  }, []);

  // Construir array P2P con IDs únicos
  const P2P = useMemo(() => {
    const result = [];
    activate.forEach((bank, index) => {
      if (bank.p2p && bank.p2p.enabled_j) {
        result.push({
          id: bank.id || bank.banco || `p2p-${index}`,
          banco: bank?.banco,
          logo_url: bank?.p2p?.logo_url,
          phone: bank?.p2p?.phone,
          rif: bank?.rif,
          cod_ban: bank?.p2p?.cod_ban,
        });
      }
    });
    return result;
  }, [activate]);

  // Efecto para seleccionar el primer banco por defecto
  useEffect(() => {
    if (P2P.length > 0 && !selectedBankName) {
      const primerBanco = P2P[0];
      setSelectedBankName(primerBanco.banco);
      if (onBankChange) onBankChange(primerBanco.banco);
    }
  }, [P2P, selectedBankName, onBankChange]);

  const handleClose = () => {
    setStep(false);
    setIconMessage(false);
  };

  const handleBankSelect = (banco) => {
    setSelectedBankName(banco.banco);
    setRef("");
    if (onBankChange) onBankChange(banco.banco);
    if (banco.banco === "Banco de Venezuela" && totalAPagar && parseFloat(totalAPagar) > 0) {
      setValue("amount", parseFloat(totalAPagar));
    }
  };

  const cedula = (event) => {
    const inputValue3 = event.target.value;
    const numericValue3 = inputValue3.replace(/[^0-9]/g, "");
    setCi(numericValue3.toString());
  };

  const numero = (event) => {
    const inputValue2 = event.target.value;
    const numericValue2 = inputValue2.replace(/[^0-9]/g, "");
    setTelefono(numericValue2.toString());
  };

  const handleChange = (event) => {
    const inputValue1 = event.target.value;
    const numericValue1 = inputValue1.replace(/[^0-9]/g, "");
    setRef(numericValue1.toString());
    if (parseInt(event.target.value.length) === 4) {
      setNotification(false);
    } else {
      setNotification(true);
      setNotification2(true);
    }
    if (parseInt(event.target.value.length) > 5) {
      setNotification2(false);
    }
    if (event.target.value === "") {
      setNotification(false);
      setNotification2(false);
    }
  };

  const selectedBank = P2P.find((banco) => banco.banco === selectedBankName);



  const onSubmit = async (data) => {
    setLoading(true);
    setIconMessage(false);

    const selectedDate = new Date(data.date);
    const currentDate = new Date();

    if (data.amount) {
      const formattedAmount = parseFloat(data.amount).toFixed(2);
      data.amount = parseFloat(formattedAmount);
    }
    if (factura) {
      data.id_docs = id_doc;
      delete data.id_servicio;
    } else if (!factura) {
      data.id_servicio = id_servicio;
      delete data.id_docs;
    }
    data.phone = data.pre + telefono;
    if (selectedBankName === "Banco de Venezuela") {
      data.id = nacionalidad + ci;
    }
    data.ref = ref;
    

    if (selectedDate > currentDate) {
      showToast("La fecha seleccionada no puede ser una fecha futura");
      return;
    }

    if (selectedBankName === "Banco de Venezuela" && (!ci || ci.length < 4)) {
      showToast("Estimado usuario, debe ingresar un documento de identidad válido");
      return;
    }

    if (!telefono || telefono.length < 7) {
      showToast("Falta un número de teléfono");
      return;
    }

    if (!ref || ref.trim() === "") {
      showToast("Estimado usuario, debe ingresar un número de referencia");
      return;
    }

    if (
      (selectedBankName === "Banco de Venezuela" && data.ref.length < 6) ||
      (selectedBankName !== "Banco de Venezuela" && data.ref.length < 4)
    ) {
      const minLength = selectedBankName === "Banco de Venezuela" ? 6 : 4;
      showToast(`Estimado usuario, debe ingresar un número de referencia de al menos ${minLength} caracteres`);
      return;
    }

    if (!data.bank || data.bank === "Seleccione el banco origen...") {
      showToast("Estimado usuario, debe seleccionar el banco origen");
      return;
    }

    if (selectedBankName === "Banco de Venezuela" && data.amount < 1) {
      showToast("Estimado usuario, debe ingresar un monto a cancelar mayor que cero");
      return;
    }

    try {
      const response = await http.post(`${url}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setIconMessage(true);
      setMsg(response.data.message);
      setReferencia(response.data.ref);
    } catch (error) {
      setLoading(false);

      if (error?.response) {
        const status = error.response.status;
        if ([409, 400, 422, 500, 503].includes(status)) {
          setMsg(error.response.data?.detail || "Error en el proceso de pago");
        } else {
          setMsg("Hubo un error de conexión. Inténtelo nuevamente.");
        }
      }
    } finally {
      setLoading(false);
      setStep(true);
    }
  };

  const showToast = (message) => {
    toast.warning(message, {
      toastId: customId,
      position: "top-center",
    });
    setLoading(false);
  };

  const watchedAmount = watch("amount");

  const isFormValid = useMemo(() => {
    const hasBank = selectedBankName !== null;
    const hasCi = selectedBankName === "Banco de Venezuela"
      ? ci?.length >= 4
      : true;
    const hasPhone = telefono?.length === 7;
    const hasRef = ref?.length >= 1;
    const hasAmount = selectedBankName === "Banco de Venezuela"
      ? (parseFloat(watchedAmount) > 0)
      : true;
    return hasBank && hasCi && hasPhone && hasRef && hasAmount;
  }, [ci, telefono, ref, selectedBankName, watchedAmount]);

  return (
    <div>
      {loading ? (
        <div className="placeholder-glow">
          <div className="mt-5 center-all">
            <div className="placeholder col-3" style={{ height: 20 }}></div>
          </div>
          {[1, 2].map((i) => (
            <div key={i} className="formasBorder border-card mt-2 d-flex align-items-center p-3" style={{ gap: 12 }}>
              <div className="placeholder rounded-circle flex-shrink-0" style={{ width: 20, height: 20 }}></div>
              <div className="flex-grow-1">
                <div className="placeholder col-4 mb-1" style={{ height: 14 }}></div>
                <div className="placeholder col-6" style={{ height: 12 }}></div>
              </div>
              <div className="placeholder flex-shrink-0" style={{ width: 60, height: 40, borderRadius: 8 }}></div>
            </div>
          ))}
          <div className="center-all mt-4">
            <div className="placeholder col-5" style={{ height: 18 }}></div>
          </div>
          <div className="center-all">
            <div className="border-card mt-2 p-3" style={{ width: "100%", maxWidth: 400 }}>
              <div className="placeholder col-6 mb-2" style={{ height: 14 }}></div>
              <div className="placeholder col-8 mb-2" style={{ height: 14 }}></div>
              <div className="placeholder col-5 mb-2" style={{ height: 14 }}></div>
            </div>
          </div>
          <div className="center-all mt-4">
            <div className="placeholder col-6" style={{ height: 18 }}></div>
          </div>
          <div className="border-card mt-2 p-3">
            <div className="placeholder col-4 mb-2" style={{ height: 14 }}></div>
            <div className="placeholder col-8 mb-2" style={{ height: 36 }}></div>
            <div className="placeholder col-4 mb-2" style={{ height: 14 }}></div>
            <div className="placeholder col-6 mb-2" style={{ height: 36 }}></div>
            <div className="placeholder col-4 mb-2" style={{ height: 14 }}></div>
            <div className="placeholder col-5 mb-2" style={{ height: 36 }}></div>
            <div className="placeholder col-4 mb-2" style={{ height: 14 }}></div>
            <div className="placeholder col-7" style={{ height: 36 }}></div>
          </div>
          <div className="placeholder col-12 mt-3" style={{ height: 44, borderRadius: 6 }}></div>
        </div>
      ) : (
      <>
      <div className="mt-5">
        <span className="center-all header-bill mt-5">Destino bancario</span>
      </div>
      {initialLoading ? (
        <div className="placeholder-glow">
          {[1, 2].map((i) => (
            <div key={i} className="formasBorder border-card mt-2 d-flex align-items-center p-3" style={{ gap: 12 }}>
              <div className="placeholder rounded-circle flex-shrink-0" style={{ width: 20, height: 20 }}></div>
              <div className="flex-grow-1">
                <div className="placeholder col-4 mb-1" style={{ height: 14 }}></div>
                <div className="placeholder col-6" style={{ height: 12 }}></div>
              </div>
              <div className="placeholder flex-shrink-0" style={{ width: 60, height: 40, borderRadius: 8 }}></div>
            </div>
          ))}
        </div>
      ) : (
      P2P?.map((banco) => (
        <div
          className={`formasBorder border-card mt-2 ${selectedBankName === banco.banco ? "selected" : ""}`}
          onClick={() => handleBankSelect(banco)}
          style={{
            cursor: "pointer",
            backgroundColor: selectedBankName === banco.banco ? "rgba(0,0,0,0.05)" : "transparent",
          }}
          key={banco.id || banco.banco}
        >
          <Row>
            <Col xs={7} sm={8} className="col-metodo-2 font-bills-details">
              <div className="col-metodo-2 me-4">
                <Form.Check
                  className="check-custom"
                  name="banco"
                  type="radio"
                  checked={selectedBankName === banco.banco}
                  onChange={() => handleBankSelect(banco)}
                />
              </div>
              <div className="col-metodo">
                <span className="title-bank">{banco.banco}</span>
                <span>{banco?.nombre}</span>
              </div>
            </Col>
            <Col xs={5} sm={4} className="col-view">
              <img className="bank-logo" src={banco.logo_url} alt={banco.banco} />
            </Col>
          </Row>
        </div>
      ))
      )}

      <span className="center-all header-bill mt-4">Realiza el pago móvil a</span>
      <div className="center-all">
        <div className="datamovil border-card mt-2">
          <div className="data-row">
            <span className="data-pago">Teléfono:</span>
            <span className="data-show">
              {selectedBank?.phone || "N/A"}
              <button className={`btn-copy ms-2${copiedField === "phone" ? " copied" : ""}`} onClick={() => copyToClipboard(selectedBank?.phone, "phone")} title="Copiar"><FaCopy /></button>
            </span>
          </div>
          <div className="data-row">
            <span className="data-pago">RIF:</span>
            <span className="data-show">
              {selectedBank?.rif}
              <button className={`btn-copy ms-2${copiedField === "rif" ? " copied" : ""}`} onClick={() => copyToClipboard(selectedBank?.rif, "rif")} title="Copiar"><FaCopy /></button>
            </span>
          </div>
          <div className="data-row">
            <span className="data-pago">Código banco:</span>
            <span className="data-show">
              {selectedBank?.cod_ban}
              <button className={`btn-copy ms-2${copiedField === "cod_ban" ? " copied" : ""}`} onClick={() => copyToClipboard(selectedBank?.cod_ban, "cod_ban")} title="Copiar"><FaCopy /></button>
            </span>
          </div>
        </div>
      </div>

      <span className="center-all header-bill mt-4">Datos del pago móvil realizado</span>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-pago border-card mt-2">
          <div className="padding-form">
            {selectedBankName === "Banco de Venezuela" && (
              <Row className="g-3">
                <Col xs={4} sm={3} xxl={2}>
                  <Form.Group className="mb-3">
                    <Form.Label>Tipo doc.</Form.Label>
                    <Form.Select
                      onChange={(e) => setNacionalidad(e.target.value)}
                      className="custom-select-no-arrow align-selector"
                    >
                      {documento.map((banco) => (
                        <option key={banco.value} value={banco.value}>
                          {banco.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={8} sm={9} xxl={10}>
                  <Form.Group className="mb-3">
                    <Form.Label>Doc. del pagador</Form.Label>
                    <Form.Control onChange={cedula} type="number" />
                  </Form.Group>
                </Col>
              </Row>
            )}

            <Row className="g-2 g-sm-4">
              <Col xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Banco de origen</Form.Label>
                  <Form.Select {...register("bank")}>
                    <option disabled selected>
                      Seleccione el banco origen...
                    </option>
                    {bancos?.map((banco) => (
                      <option key={banco.value} value={banco.value}>
                        {banco.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row className="g-2 g-sm-4">
              <Col xs={4} sm={3} xxl={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Prefijo</Form.Label>
                  <Form.Select {...register("pre")} className="custom-select-no-arrow align-selector">
                    {telefonos?.map((banco) => (
                      <option key={banco.value} value={banco.value}>
                        {banco.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col xs={8} sm={9} xxl={9}>
                <Form.Group className="mb-3">
                  <Form.Label>Número teléfonico</Form.Label>
                  <Form.Control type="text" onChange={numero} value={telefono} maxLength="7" />
                </Form.Group>
              </Col>
            </Row>

            <Row className="g-2 g-sm-4">
              {selectedBankName === "Banco de Venezuela" ? (
                <Col xs={12} sm={6}>
                  <Form.Group controlId="amount">
                    <Form.Label
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "7px",
                      }}
                    >
                      Monto en Bs
                      {totalAPagarLoading && (
                        <span className="text-muted small"> (Cargando...)</span>
                      )}
                    </Form.Label>
                    <Controller
                      control={control}
                      name="amount"
                      render={({ field: { onChange, value } }) => {
                        // Si hay un totalAPagar y el campo está vacío, usarlo
                        const currentValue = value || (totalAPagar && parseFloat(totalAPagar) > 0 ? parseFloat(totalAPagar) : 0);
                        return (
                          <CurrencyField
                            className="form-control"
                            disabled={totalAPagarLoading}
                            onValueChange={(values) => {
                              if (values?.floatValue) {
                                const roundedValue = values.floatValue.toFixed(2);
                                onChange(parseFloat(roundedValue));
                              } else {
                                onChange(null);
                              }
                            }}
                            decimalSeparator={","}
                            thousandSeparator={true}
                            value={currentValue}
                          />
                        );
                      }}
                    />
                    {/* Mostrar el monto mientras carga */}
                    {totalAPagarLoading && totalAPagar && (
                      <div className="text-muted small mt-1">
                        Monto a pagar: {parseFloat(totalAPagar).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")} Bs
                      </div>
                    )}
                  </Form.Group>
                </Col>
              ) : (
                <Col xs={12} sm={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Número de referencia</Form.Label>
                    <Form.Control type="text" onChange={handleChange} value={ref} maxLength="4" />
                  </Form.Group>
                  {notification && selectedBankName === "Banco Plaza" && (
                    <p className="input-notification text-danger text-start mb-0">
                      Ingrese los últimos 4 dígitos de su referencia
                    </p>
                  )}
                </Col>
              )}

              <Col xs={12} sm={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Fecha del pago</Form.Label>
                    <div className="input-fecha-wrapper">
                    <Form.Control
                      type="text"
                      id="fecha"
                      className="input-fecha"
                      value={displayDate}
                      onChange={handleDateChange}
                      placeholder="dd/mm/yyyy"
                      maxLength={10}
                      ref={fechaRef}
                    />
                    <input
                      type="date"
                      ref={hiddenDateRef}
                      onChange={handleHiddenDateChange}
                      style={{
                        position: "absolute",
                        width: 0,
                        height: 0,
                        opacity: 0,
                        pointerEvents: "none",
                      }}
                      tabIndex={-1}
                    />
                    <FiCalendar
                      className="input-fecha-icon"
                      onClick={handleIconClick}
                      style={{ cursor: "pointer", pointerEvents: "auto" }}
                    />
                  </div>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              {selectedBankName === "Banco de Venezuela" && (
                <Col xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Número de referencia</Form.Label>
                    <Form.Control type="text" onChange={handleChange} value={ref} maxLength="12" />
                  </Form.Group>
                  {notification2 && selectedBankName === "Banco de Venezuela" && (
                    <p className="input-notification text-danger mb-0">Ingrese entre 6 a 12 dígitos</p>
                  )}
                </Col>
              )}
            </Row>
          </div>
        </div>

        <Button type="submit" className="pay-btn" disabled={!isFormValid || loading || totalAPagarLoading}>
          {loading ? (
            <>
              <div className="spinner"></div>
            </>
          ) : (
            <span>Pagar</span>
          )}
        </Button>
      </form>

      <Modal size="md" show={step} centered onHide={() => {}} backdrop="static" keyboard={false}>
        <div className="d-flex justify-content-end">
          <button onClick={handleClose} className="eliminarBG me-4 mt-2">
            <RxCross2 className="color-primary" style={{ fontSize: 35 }} />
          </button>
        </div>
        <Modal.Body className="text-center p-4">
          <div className="center-all">
            {iconMessage ? (
              <FiCheck className="success-icon" size={120} />
            ) : (
              <RxCross1 className="error-icon" size={120} />
            )}
          </div>
          <h3 className="title-color mb-3">{msg || "Sin mensaje disponible"}</h3>
          {iconMessage ? (
            <h5 className="font-styles mb-3">
              <strong>Referencia: {referencia}</strong>
            </h5>
          ) : (
            ""
          )}
        </Modal.Body>
      </Modal>
      </>
      )}
    </div>
  );
};

export default PagoP2P;